import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectUrl } from './DataObjectUrl';
import {
  DataObjectRelationsDataConflictsDto,
  DataObjectRelationsDataConflictsDtoSchema,
} from '../schema/DataObjectRelationsDataConflictsDtoSchema';

const getDataObjectRelationsDataConflicts = (filters: any) =>
  apiClient
    .get<DataObjectRelationsDataConflictsDto>(
      expand(DataObjectUrl.RELATIONS_DATA_CONFLICTS, filters),
    )
    .then((response) =>
      DataObjectRelationsDataConflictsDtoSchema.parse(response.data),
    );

export const useGetDataObjectRelationsDataConflicts = createApiQueryHook(
  ['data-object-relations-data-conflicts'],
  getDataObjectRelationsDataConflicts,
);
